import constants from '../constants.js';

const VehiclesId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const VehiclesTitle = {
  displayName: 'Title',
  dataAt: "Title",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  optionsAt: "Title",
  required: true
};

const VehiclesCode = {
  displayName: 'Code',
  dataAt: "Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const VehiclesClass = {
  displayName: 'Class',
  dataAt: "Class",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const VehiclesCountryCode = {
  displayName: 'Country Code',
  dataAt: "CountryCode",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single',
  required: true
};

const VehiclesSupplierCode = {
  displayName: 'Supplier Code',
  dataAt: "SupplierCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const VehiclesLocationCode = {
  displayName: 'Location Code',
  dataAt: "LocationCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const VehiclesIsMineSpec = {
  displayName: 'Mine Spec',
  dataAt: 'IsMineSpec',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const VehicleAttributes = {
  displayName: 'Attributes',
  dataAt: 'Attributes',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: 'VehicleAttributes'
};

const VehiclesImageUrl = {
  displayName: 'Image Url',
  dataAt: 'ImageUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'CarVehicle',
  uploadType: "image"
};

const VehiclesIsDeleted = {
  displayName: 'IsDeleted',
  dataAt: 'IsDeleted',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  disabled: false
};

const VehiclesTabsInfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [
    VehiclesId,
    VehiclesTitle,
    VehiclesCode,
    VehiclesClass,
    VehiclesCountryCode,
    VehiclesSupplierCode,
    VehiclesLocationCode,
    VehiclesIsMineSpec,    
    VehicleAttributes,
    VehiclesImageUrl,
    VehiclesIsDeleted
  ]
};

const VehiclesTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [VehiclesTabsInfoPanel]
};

const VehiclesNameLabel = {dataAt: 'Title', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Title:'};

const VehiclesAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Car Supplier',
  data: {Title: '', Code: ''},
  dataAt: '',
  children: [
    VehiclesTitle,
    VehiclesCode,
    VehiclesClass,
    VehiclesCountryCode,
    VehiclesSupplierCode,
    VehiclesLocationCode
  ],
  endpoint: 'Vehicles'
};

const VehiclesResource = {
  displayName: 'Vehicles',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [VehiclesNameLabel, VehiclesTabs],
  endpoint: 'Vehicles',
  routeParamId: 'vehicleId',
  canDelete: true,
  removeParamId: 'vehicleId'
};

let vehicleGridCols = [
  { name: "Title", key: "Title" },
  { name: "Code", key: "Code" },
  { name: "Class", key: "Class" },
  { name: "Supplier Code", key: "SupplierCode" },
  { name: "Mine Spec", key: "IsMineSpec" },
  { name: "Location Code", key: "LocationCode" },
  { name: "Country Code", key: "CountryCode" },
  { name: "Deleted", key: "IsDeleted", excludeFromFilters: true },
];

const VehiclesList = {
  rootNode: true,
  displayName: "Cars",
  displayAs: constants.DISPLAY_AS.SEARCH_BY,
  endpoint: "Vehicles",
  targetChoices: vehicleGridCols,
  canSearchDeleted: true,
  resultsSettings: {
    displayName: "Cars",
    gridItem: VehiclesResource,
    gridAdd: VehiclesAddResource,
    gridCols: vehicleGridCols,
    routeParamId: "vehicleId",
  },
};

export default {
  VehiclesList,
  VehiclesResource,
  VehiclesAddResource,
  VehiclesNameLabel,
  VehiclesTabs,
  VehiclesTabsInfoPanel,
  VehiclesId,
  VehiclesTitle,
  VehiclesCode,
  VehiclesClass,
  VehiclesCountryCode,
  VehiclesSupplierCode,
  VehiclesLocationCode,
  VehiclesIsMineSpec,    
  VehicleAttributes,
  VehiclesImageUrl
}


// WEBPACK FOOTER //
// ./src/config/fields/vehicles.js